<template>
<aside class="aside-menu">

</aside>
</template>

<script>
export default {
  name: 'theaside'
}
</script>



// WEBPACK FOOTER //
// Aside.vue?3fbe77df